import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon, Cascader, Divider, Input, Popover, message } from 'antd';
import _ from 'lodash';

import defaultLangOptions, { getLanguage, getLanguageOption } from '../data/languageCascaderData';
import { transformMultiLangInfos } from '../utils/multiLangInfo';


const addLanguageGuidePopoverContent = (
  <div className="creation-pack-with-type-multi-language-choice-guide">
    <FormattedMessage
      id="Upload.PkgCreation.createPack.packInfoLanguage.guide"
      defaultMessage="Add the name and description of the pack in various languages. The added information is available to users in countries where those packs are exposed and sold."
    />
  </div>
)

class PackMultiLangInfoForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      multiLangCodeList: [],
      langOptions: [],
    }
  }

  componentDidMount() {
    const { names, descriptions } = this.props;

    const multiLangCodeList = _.keys(transformMultiLangInfos(names, descriptions));
    const langOptions = defaultLangOptions.filter(option =>
      option.code !== 'en' && !multiLangCodeList.includes(option.code)
    )

    const othersIndex = langOptions.findIndex((option) => option.code === 'others');
    langOptions[othersIndex].others = langOptions[othersIndex].others.filter(option => 
      option.code !== 'en' && !multiLangCodeList.includes(option.code)
    );

    this.setState({
      multiLangCodeList,
      langOptions,
    });
  }

  addMultiLangCode = (languageCode, index = undefined) => {
    const { multiLangCodeList, langOptions } = this.state;
    const { names, setNames, descriptions, setDescriptions } = this.props;

    if (languageCode !== "" && multiLangCodeList.includes(languageCode)) {
      return;
    }

    if (index === undefined) {
      multiLangCodeList.push(languageCode);
    } else {
      multiLangCodeList[index] = languageCode;
    }

    const othersIndex = langOptions.findIndex((option) => option.code === 'others');
    langOptions[othersIndex].others = langOptions[othersIndex].others.filter(option => option.code !== languageCode);
  
    this.setState({
      multiLangCodeList,
      langOptions: langOptions.filter(option => option.code !== languageCode),
    }, () => {
      if (languageCode === "") {
        return;
      }

      names[languageCode] = "";
      descriptions[languageCode] = "";
      setNames(names);
      setDescriptions(descriptions);
    });
  }

  removeMultiLangCode = (languageCode, index) => {
    const { multiLangCodeList, langOptions } = this.state;
    const { names, setNames, descriptions, setDescriptions } = this.props;

    if (multiLangCodeList[index] !== languageCode) {
      console.log('Failed to find language Code in PackMultiLangInfoForm');
      message.error('Something went wrong. Please try again.');
      return;
    }

    multiLangCodeList.splice(index, 1);

    if (languageCode === "") {
      this.setState({
        multiLangCodeList,
      });
      return;
    }

    const removedLanguageOption = getLanguageOption(languageCode);
    if (removedLanguageOption.isOther === true) {
      const otherOptionIndex = langOptions.findIndex(option => option.code === 'others');
      
      if (otherOptionIndex < 0) {
        console.log('Failed to find others of langOptions');
        message.error('Something went wrong. Please try again.');
        return;
      }
      langOptions[otherOptionIndex].others.splice(removedLanguageOption.index, 0, removedLanguageOption.option);
    }
    if (removedLanguageOption.isOther === false) {
      // en을 제외해야 하기 때문에 index - 1이 기존 위치
      langOptions.splice(removedLanguageOption.index - 1, 0, removedLanguageOption.option);
    }
    
    this.setState({
      multiLangCodeList,
      langOptions,
    }, () => {
      _.unset(names, languageCode);
      _.unset(descriptions, languageCode);
      setNames(names);
      setDescriptions(descriptions);
    });
  }

  generateInfoForm = (languageCode, index, multiLangInfo) => {
    const { langOptions } = this.state;
    const { names, setNames, descriptions, setDescriptions, isEditing, disabledName, disabledDescription } = this.props;
    
    return (
      <div key={languageCode === "" ? `${index}` : `${languageCode}`}>
        <div className="creation-pack-with-type-multi-language-box"> 
          <div className="creation-pack-with-type-multi-language-label-box">
            <div className="creation-pack-with-type-multi-language-label">
              <FormattedMessage 
                id="Upload.PkgCreation.createPack.packInfoLanguage"
                defaultMessage="Language"
              />
            </div>
          </div>
          <div className="creation-pack-with-type-multi-language-choice-box">
            { languageCode !== "" ? 
                <div className="creation-pack-with-type-multi-language-choice">
                  { getLanguage(languageCode) }
                </div>
              : <Cascader placeholder='' fieldNames={{ label: 'language', value: 'code', children: 'others' }}
                  allowClear={false}
                  className='creation-pack-with-type-cascader-language-selection'
                  popupClassName='creation-pack-with-type-cascader-language-selection-popup'
                  options={langOptions}
                  disabled={isEditing}
                  displayRender={() => <span style={{color:'rgba(0, 0, 0, 0.38)'}}>{'Languages'}</span>}
                  onChange={(value) => {
                    const langCode = value.pop();
                    this.addMultiLangCode(langCode, index);
                  }} />
            }
            { !isEditing && // editing 상태가 아닌 creating 상태인 경우 삭제 버튼 표시
              <Icon type="close-circle" theme="filled"
                style={{ fontSize:'18px', color:'#FF6060', cursor:'pointer', marginLeft:'8px' }}
                onClick={() => this.removeMultiLangCode(languageCode, index)}
              />
            }
          </div>
        </div>
        <div className="creation-pack-with-type-multi-language-pack-name-box">
          <div className="creation-pack-with-type-multi-language-label-box">
            <div className="creation-pack-with-type-multi-language-label">
              <FormattedMessage
                id="Upload.PkgCreation.createPack.packName"
                defaultMessage="Pack Name"
              />
            </div>
          </div>
          <div className='creation-pack-with-type-input-value-box'>
            <Input className='creation-pack-with-type-input-box-pack-name'
              name={`${languageCode}-name`}
              value={multiLangInfo.name}
              disabled={ languageCode === "" || disabledName }
              onChange={(e) => {
                names[languageCode] = e.target.value;
                setNames(names);
              }}
            />
          </div>
        </div>
        <div className="creation-pack-with-type-multi-language-pack-description-box">
          <div className="creation-pack-with-type-multi-language-label-box">
            <div className="creation-pack-with-type-multi-language-label">
              <FormattedMessage
                id="Upload.PkgCreation.createPack.packDescription"
                defaultMessage="Pack Description"
              />
            </div>
          </div>
          <div className='creation-pack-with-type-input-pack-description-box'>
            <Input.TextArea className='creation-pack-with-type-input-box-pack-description'
              name={`${languageCode}-packDescription`}
              
              value={multiLangInfo.description}
              disabled={ languageCode === "" || disabledDescription }
              onChange={(e) => {
                descriptions[languageCode] = e.target.value;
                setDescriptions(descriptions);
              }}
            />
          </div>
        </div>
      </div>
    )
  }

  render () {
    const { multiLangCodeList, langOptions } = this.state;
    const { names, descriptions, isEditing } = this.props;

    const multiLangInfos = transformMultiLangInfos(names, descriptions);

    return (
      <div>
        {
          multiLangCodeList.map((languageCode, index) =>
            this.generateInfoForm(languageCode, index, (multiLangInfos[languageCode] || { name: '', description: '' }))
          )
        }
        { !isEditing &&
        <div className='creation-pack-with-type-multi-language-box'>
          <div className='creation-pack-with-type-multi-language-selection-label-box'>
            <div className='creation-pack-with-type-multi-language-selection-label'>
              <FormattedMessage
                id='Upload.PkgCreation.createPack.packInfoLanguage.choice'
                defaultMessage='Add language'
              />
            </div>
            <Popover content={addLanguageGuidePopoverContent}>
              <div style={{color:'#a202ff', marginLeft:'12px', cursor: 'pointer'}}>
                <Icon type="question-circle" style={{width : 16 }}/>
              </div>
            </Popover>
          </div>
          <div style={{ display:'flex', alignItems:'center', marginLeft:'16px' }}>
            <Cascader placeholder='' fieldNames={{ label: 'language', value: 'code', children: 'others' }}
              allowClear={false}
              disabled={isEditing}
              className='creation-pack-with-type-cascader-language-selection'
              popupClassName='creation-pack-with-type-cascader-language-selection-popup'
              options={langOptions}
              displayRender={() => <span style={{color:'rgba(0, 0, 0, 0.38)'}}>{'Languages'}</span>}
              onChange={(value, options) => {
                const langCode = value.pop();
                this.addMultiLangCode(langCode);
              }} />
            <Icon type="plus-circle" theme="filled"
              style={{ fontSize:'18px', color:'rgba(0, 0, 0, 0.38)', cursor:'pointer', marginLeft:'8px' }}
              onClick={() => this.addMultiLangCode("")}
            />
          </div>
        </div>
        }
        <Divider style={{margin: '0px'}} />
      </div>
    )
  }
}

export default PackMultiLangInfoForm;